import HeaderApp from './HeaderApp';

export default HeaderApp;
// Здесь на данный момент пока только компонент Header
// который импортируется в shared/headers/_modern.html.erb
// и используется на страницах hot, about, contacts, home
// TODO: необходимо обернуть страницы hot, about, contacts, home
//  (и возможно другие) в компонент Layout и удалить компонент из
//  _modern.html.erb
// https://leveltravel.atlassian.net/browse/LT-25428
